<template>
  <div>
    <div class="">
      <div class="h-full">
        <div class="w-full flex items-center justify-between mb-3">
          <div class="flex items-center gap-2">
            <input
              type="checkbox"
              :checked="allChecked"
              class="h-4 w-4"
              @change="toggleCheckAll()"
            />

            <span class="text-dark-600">Select All</span>
          </div>

          <!-- <div>
            <span
              >{{ currentPage == 0 ? currentPage + 1 : pageSize + currentPage }}
              -
              {{
                currentPage == 0
                  ? pageSize > data.length
                    ? data.length
                    : pageSize
                  : pageSize + visibleData.length
              }}
              of {{ data.length }}</span
            >
          </div> -->
        </div>
        <table
          v-for="emp in data"
          :key="emp.employeeId"
          class="table-auto w-full my-8 overflow-y-auto"
        >
          <tbody class="">
            <tr>
              <td
                :class="[
                  transposed[0].id === emp.employeeId &&
                  getKey(emp, emp.firstName) === transposed[0].field
                    ? 'bg-newerDirtyBrown text-white'
                    : '',
                  holdData.includes(emp) &&
                  getKey(emp, emp.firstName) === transposed[0].field
                    ? 'bg-newerDirtyBrown text-white'
                    : '',
                ]"
                class="flex gap-2 px-1 py-3 border-2 border-outlineGray items-center bg-newerDirtyBrown text-left font-bold capitalize text-sm text-header border-t-1"
              >
                <div class="text-center">
                  <input
                    @change="onRowSelect(emp)"
                    :checked="
                      holdData.includes(emp) || findEmpId(emp.employeeId)
                    "
                    type="checkbox"
                    name=""
                    id=""
                  />
                </div>
                <span>First Name</span>
              </td>

              <td
                @click="setActive(emp.employeeId, 'firstName')"
                class="border-2 border-outlineGray text-left text-sm font-medium text=dark-800 relative group-hover:bg-newerDirtyBrown group-hover:border-outlineGray w-2/3 bg-highlight"
              >
                <div class="inline-block items-center gap-2 mx-2">
                  <div
                    v-if="emp.picture"
                    class="border w-9 h-9 rounded-full overflow-hidden"
                  >
                    <img
                      class="-full"
                      :src="emp.picture"
                      :alt="emp.firstName + ' ' + emp.lastName"
                    />
                  </div>
                  <div
                    v-else
                    :style="`background-color:${getAvatar(emp).color}`"
                    class="p-2 h-9 w-9 text-sm text-white font-medium rounded-full"
                  >
                    {{ getAvatar(emp).name }}
                  </div>
                </div>
                <span
                  v-show="
                    transposed[0].id !== emp.employeeId ||
                    getKey(emp, emp.firstName) !== transposed[0].field
                  "
                >
                  {{ emp.firstName }}</span
                >
                <easiTextInput
                  type="text"
                  readonly
                  :class="
                    transposed[0].id === emp.employeeId &&
                    getKey(emp, emp.firstName) === transposed[0].field
                      ? 'z-20 absolute top-0 left-0'
                      : undefined
                  "
                  v-show="
                    transposed[0].id === emp.employeeId &&
                    getKey(emp, emp.firstName) === transposed[0].field
                  "
                  v-model="emp.firstName"
                  @input="checkValue($event, emp, 'firstName')"
                ></easiTextInput>
              </td>
            </tr>

            <tr>
              <td
                :class="[
                  transposed[0].id === emp.employeeId &&
                  getKey(emp, emp.lastName) === transposed[0].field
                    ? 'bg-newerDirtyBrown text-white'
                    : '',
                  holdData.includes(emp) &&
                  getKey(emp, emp.lastName) === transposed[0].field
                    ? 'bg-newerDirtyBrown text-white'
                    : '',
                ]"
                class="flex gap-3 border-2 border-outlineGray px-2 py-3 bg-newerDirtyBrown text-left font-bold capitalize text-sm text-header border-t-0"
              >
                <span>Last Name</span>
              </td>

              <td
                @click="setActive(emp.employeeId, 'lastName')"
                class="border-2 border-outlineGray text-left text-sm p-2 font-medium text=dark-800 relative group-hover:bg-newerDirtyBrown group-hover:border-outlineGray w-52 bg-highlight"
              >
                <span
                  v-show="
                    transposed[0].id !== emp.employeeId ||
                    getKey(emp, emp.lastName) !== transposed[0].field
                  "
                >
                  {{ emp.lastName }}</span
                >
                <easiTextInput
                  type="text"
                  readonly
                  :class="
                    transposed[0].id === emp.employeeId &&
                    getKey(emp, emp.lastName) === transposed[0].field
                      ? 'z-20 absolute top-0 left-0'
                      : undefined
                  "
                  v-show="
                    transposed[0].id === emp.employeeId &&
                    getKey(emp, emp.lastName) === transposed[0].field
                  "
                  v-model="emp.lastName"
                  @input="checkValue($event, emp, 'lastName')"
                ></easiTextInput>
              </td>
            </tr>

            <tr>
              <td
                :class="[
                  transposed[0].id === emp.employeeId &&
                  getKey(emp, emp.grossPay) === transposed[0].field
                    ? 'bg-primary text-white'
                    : '',
                  holdData.includes(emp) &&
                  getKey(emp, emp.grossPay) === transposed[0].field
                    ? 'bg-primary text-white'
                    : '',
                ]"
                class="flex border-2 border-outlineGray gap-3 px-2 py-3 bg-newerDirtyBrown font-bold capitalize text-sm text-header border-t-0 text-center"
              >
                <span>Gross Pay</span>
              </td>

              <td
                @click="setActive(emp.employeeId, 'grossPay')"
                class="border-2 border-outlineGray text-left text-sm p-2 font-medium text=dark-800 relative group-hover:bg-newerDirtyBrown group-hover:border-outlineGray w-52 bg-white"
              >
                <span
                  v-show="
                    transposed[0].id !== emp.employeeId ||
                    getKey(emp, emp.grossPay) !== transposed[0].field
                  "
                >
                  {{ formatAmount(emp.grossPay) }}</span
                >
                <easiTextInput
                  type="number"
                  :class="
                    transposed[0].id === emp.employeeId &&
                    getKey(emp, emp.grossPay) === transposed[0].field
                      ? 'z-20 absolute top-0 left-0'
                      : undefined
                  "
                  v-show="
                    transposed[0].id === emp.employeeId &&
                    getKey(emp, emp.grossPay) === transposed[0].field
                  "
                  v-model="emp.grossPay"
                  @input="checkValue($event, emp, 'grossPay')"
                ></easiTextInput>
              </td>
            </tr>
            <tr>
              <td
                :class="[
                  transposed[0].id === emp.employeeId &&
                  'netPay' === transposed[0].field
                    ? 'bg-primary text-white'
                    : '',
                  holdData.includes(emp) && 'netPay' === transposed[0].field
                    ? 'bg-primary text-white'
                    : '',
                ]"
                class="flex border-2 border-outlineGray gap-3 px-2 py-3 bg-newerDirtyBrown text-left font-bold capitalize text-sm text-header border-t-0"
              >
                <span>Net Pay</span>
              </td>

              <td
                @click="setActive(emp.employeeId, 'netPay')"
                class="border-2 border-outlineGray text-left text-sm p-2 font-medium text=dark-800 relative group-hover:bg-newerDirtyBrown group-hover:border-newerDirtyBrown w-52 bg-white"
              >
                <!-- <span
                  v-show="
                    transposed[0].id !== emp.employeeId ||
                    'netPay' !== transposed[0].field
                  "
                >
                  {{ formatAmount(emp.netPay) }}</span
                > -->
                <div class="flex flex-row justify-between relative w-full">
                  <span
                    v-show="
                      transposed[0].id !== emp.employeeId ||
                      'netPay' !== transposed[0].field
                    "
                  >
                    {{ formatAmount(emp.netPay) }}</span
                  >
                  <Tag
                    v-if="emp && emp.prorate && emp.prorate.proratedSalary"
                    style="width: 80px"
                    severity="info"
                    class="justify-end justify-self-end self-start -mt-2 text-xs"
                  >
                    <span class="text-xs">PRORATED</span></Tag
                  >
                </div>

                <easiTextInput
                  type="number"
                  readonly
                  :class="
                    transposed[0].id === emp.employeeId &&
                    'netPay' === transposed[0].field
                      ? 'z-20 absolute top-0 left-0'
                      : undefined
                  "
                  v-show="
                    transposed[0].id === emp.employeeId &&
                    'netPay' === transposed[0].field
                  "
                  v-model="emp.netPay"
                  @input="checkValue($event, emp, 'netPay')"
                ></easiTextInput>
              </td>
            </tr>
            <tr
              v-for="name in allowanceNames"
              :key="name"
              v-show="
                showAllEmployee === emp.employeeId &&
                !hiddenFields.includes(name)
              "
            >
              <td
                :class="[
                  transposed[0].id === emp.employeeId &&
                  name === transposed[0].field
                    ? 'bg-primary text-white'
                    : '',
                  holdData.includes(emp) && name === transposed[0].field
                    ? 'bg-primary text-white'
                    : '',
                ]"
                class="flex border-outlineGray gap-3 px-2 py-3 bg-newerDirtyBrown text-left font-bold capitalize text-sm text-header border-2 border-t-0"
              >
                <span>{{ name }}</span>
              </td>

              <td
                @click="setActive(emp[`${name}_id`], name)"
                class="border-2 border-outlineGray text-left text-sm p-2 font-medium text=dark-800 relative group-hover:bg-newerDirtyBrown group-hover:border-newerDirtyBrown w-52 bg-white"
              >
                <span
                  v-show="
                    transposed[0].id !== emp[`${name}_id`] ||
                    name !== transposed[0].field
                  "
                >
                  {{
                    emp.usePercentage
                      ? formatAmount(
                          calculatePercentage(emp.grossPay, emp[name])
                        )
                      : formatAmount(emp[name])
                  }}</span
                >

                <easiTextInput
                  type="number"
                  :class="
                    transposed[0].id === emp[`${name}_id`] &&
                    name === transposed[0].field
                      ? 'z-20 absolute top-0 left-0'
                      : undefined
                  "
                  v-show="
                    transposed[0].id === emp[`${name}_id`] &&
                    name === transposed[0].field
                  "
                  v-model="emp[name]"
                  @input="checkValue($event, emp, name)"
                ></easiTextInput>
              </td>
            </tr>

            <tr v-show="showAllEmployee === emp.employeeId">
              <td
                :class="[
                  transposed[0].id === emp.employeeId &&
                  getKey(emp, emp.deductions) === transposed[0].field
                    ? 'bg-primary text-white'
                    : '',
                  holdData.includes(emp) &&
                  getKey(emp, emp.deductions) === transposed[0].field
                    ? 'bg-primary text-white'
                    : '',
                ]"
                class="flex border-outlineGray gap-3 px-2 py-3 bg-newerDirtyBrown text-left font-bold capitalize text-sm text-header border-2 border-t-0"
              >
                <span>deductions</span>
              </td>

              <td
                @click="setActive(emp.employeeId, 'deductions')"
                class="border-2 border-outlineGray text-left text-sm p-2 font-medium text=dark-800 relative group-hover:bg-indigo-100 group-hover:border-indigo-300 w-52 bg-white"
              >
                <span
                  v-show="
                    transposed[0].id !== emp.employeeId ||
                    getKey(emp, emp.deductions) !== transposed[0].field
                  "
                >
                  {{ getDeductionLabel(emp.deductions).join(",") }}</span
                >
              </td>
            </tr>
            <!--   <tr v-show="showAllEmployee === emp.employeeId">
              <td
                :class="[
                  transposed[0].id === emp.employeeId &&
                  getKey(emp, emp.branch) === transposed[0].field
                    ? 'bg-primary text-white'
                    : '',
                  holdData.includes(emp) &&
                  getKey(emp, emp.branch) === transposed[0].field
                    ? 'bg-primary text-white'
                    : '',
                ]"
                class="flex gap-3 px-2 py-3 bg-indigo-100 text-left font-bold capitalize text-sm text-header border-2 border-t-0 text-center"
              >
                <span>Branch</span>
              </td>

              <td
                @click="setActive(emp.employeeId, 'branch')"
                class="border-2 border-indigo-200 text-left text-sm p-2 font-medium text=dark-800 relative group-hover:bg-indigo-100 group-hover:border-indigo-300 w-52 bg-white"
              >
                <span
                  v-show="
                    transposed[0].id !== emp.employeeId ||
                    getKey(emp, emp.branch) !== transposed[0].field
                  "
                >
                  {{ emp.branch }}</span
                >
                <easiSelectInput2
                  required
                  class="mt-1 mb-3"
                  @update="updateSelect($event, 'branch', emp)"
                  :value="emp.branch"
                  :options="[]"
                  v-show="
                    transposed[0].id === emp.employeeId &&
                    getKey(emp, emp.branch) === transposed[0].field
                  "
                  :class="
                    transposed[0].id === emp.employeeId &&
                    getKey(emp, emp.branch) === transposed[0].field
                      ? 'z-20 absolute -top-1 left-0 right-0'
                      : undefined
                  "
                />
              </td>
            </tr> -->

            <tr
              class="max-w-full min-w-full bg-newAsh border border-outlineGray"
            >
              <td class="max-w-full">
                <div
                  class="w-full bg-newAsh text-dark-900 flex items-center justify-start text-xs py-1 pl-1"
                  @click="showAll(emp.employeeId)"
                >
                  <span
                    class="text-left pl-1 w-full"
                    v-if="showAllEmployee === emp.employeeId"
                    >Less Information</span
                  >
                  <span class="text-left pl-1" v-else>More Information</span>
                  <i
                    :class="
                      showAllEmployee === emp.employeeId
                        ? 'fas fa-angle-right'
                        : 'fas fa-angle-down'
                    "
                    class="invisible cursor-pointer text-base text-dark-600"
                  />
                </div>
              </td>
              <td>
                <div
                  class="max-w-full bg-newAsh text-dark-900 flex items-center justify-between text-xs py-1 px-3"
                  @click="showAll(emp.employeeId)"
                >
                  <span class="invisible">Less Information</span>
                  <i
                    :class="
                      showAllEmployee !== emp.employeeId
                        ? 'fas fa-angle-right'
                        : 'fas fa-angle-down'
                    "
                    class="cursor-pointer text-base text-dark-600"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      @click="reset"
      :class="!transposed[0].id.length ? 'pointer-events-none' : ''"
      class="bg-transparent fixed inset-0"
    ></div>

    <!-- <easiPagin
      v-if="data.length"
      :data="data"
      @page:update="updatePage"
      :currentPage="currentPage"
      :pageSize="pageSize"
      class="my-4"
    /> -->
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import { helperFunctions } from "@/composable/helperFunctions";

export default {
  setup() {
    const { formatAmount, calculatePercentage } = helperFunctions;
    return { formatAmount, calculatePercentage };
  },
  emits: ["data", "selectedData", "mobileData"],
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    routable: {
      type: Boolean,
      default: false,
    },
    hideAllowances: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: [],
    },
    header: {
      type: Array,
      default: [],
    },
    mapData: {
      type: Array,
      default: [],
    },
    frozenFields: {
      type: Array,
      default: [],
    },
    highlight: {
      type: Array,
      default: [],
    },
    useSelect: {
      type: Array,
      default: [],
    },
    mandatory: {
      type: Array,
      default: [],
    },
    allowanceNames: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      visibleData: [],
      currentPage: 0,
      pageSize: 15,
      employmentTypes: [
        {
          label: "Fulltime",
          value: "FULLTIME",
        },
        {
          label: "Contract",
          value: "CONTRACT",
        },
        {
          label: "Part Time",
          value: "PARTTIME",
        },
        {
          label: "Volunteer",
          value: "VOLUNTEER",
        },

        {
          label: "NYSC",
          value: "NYSC",
        },
        {
          label: "Internship",
          value: "INTERNSHIP",
        },

        {
          label: "Apprentice",
          value: "APPRENTICE",
        },
      ],
      hiddenFields: ["prorate"],
      showAllEmployee: "",
      showInput: false,
      transposed: [{ id: "", field: "" }],
      selectedEmployees: null,
      editingRows: [],
      columns: null,
      holdData: [],
      active: "",
      allChecked: false,
    };
  },

  computed: {
    style() {
      return " padding-top: 0.75rem; padding-bottom: 0.75rem; background-color: #E0E7FF; line-height: 16px; font-weight: 700; letter-spacing: 0.025em; text-align: left;  text-transform: capitalize; border-width: 1px; border-top-width: 1px; background: rgba(240, 247, 235, 1);;margin-bottom: 10px;color: #515251; border: 1px solid #E7E8E7; font-size: 12px;";
    },
    activeHeader() {
      return " padding-top: 0.75rem; padding-bottom: 0.75rem; background-color: #E7E8E7; line-height: 16px; font-weight: 700; letter-spacing: 0.025em; text-align: left;  text-transform: capitalize; border-width: 2px; border-top-width: 0; background: #E7E8E7;margin-bottom: 10px;color: #ffffff; font-size: 12px;";
    },
    checkStyle() {
      return " padding-top: 0.75rem; padding-bottom: 0.75rem; background-color: #E0E7FF;  border-width: 2px; border-top-width: 0; background: #E0E0E0;margin-bottom: 10px;border-top-left-radius: 0.5rem;border-bottom-left-radius: 0.5rem; border: 1px solid #0A244F";
    },
    lastHeaderStyle() {
      return " padding-top: 0.75rem; padding-bottom: 0.75rem; background-color: #E0E7FF; line-height: 16px; font-weight: 700; letter-spacing: 0.025em; text-align: left;  text-transform: capitalize; border-width: 2px; border-top-width: 0; background: rgba(240, 247, 235, 1);;margin-bottom: 10px;border-top-right-radius: 0.5rem;border-bottom-right-radius: 0.5rem;color: #515251; font-size: 14px; ";
    },
    label() {
      return (str) =>
        str
          .split(".")
          .pop()
          .replace(/([A-Z])/g, " $1")
          .toUpperCase();
    },
    freeze() {
      return (field) => {
        if (this.frozenFields.includes(field.field)) {
          return true;
        }
        return false;
      };
    },
    highlightField() {
      return (field) => {
        if (this.highlight.includes(field)) {
          return "background: rgba(240, 247, 235, 1); box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);";
        }
        return "background: #FCFCFC;";
      };
    },
    selectedDataArr() {
      return this.data;
    },
    // mandatoryField() {
    //   return (field) => {
    //     if (this.mandatory.includes(field)) {
    //       return "border: 1px solid #FFF0EC";
    //     }
    //   };
    // },
  },
  watch: {
    selectedDataArr() {
      this.allChecked = false;
    },
  },

  methods: {
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map((item) => [item[key], item])).values()];
    },
    getDeductionLabel(arr) {
      if (arr && arr.length) {
        const data = arr.map((item) => {
          if (item === "PAYE") return "PAYE";
          if (item === "Pension") return "Pension";
          if (item === "NHF") return "NHF";
          if (item === "NSITF") return "NSITF";
          if (item === "ITF") return "ITF";
          if (item === "WHT") return "WHT";
          if (item === "Group_Life_Insurance") return "Life Insurance";
          if (item === "Employee_Life_Assurance") return "Life Assurance";
          if (item === "HMO") return "HMO";
          if (item === "Business_Expense") return "Business Expense";
          if (item === "Gratuity") return "Gratuity";
        });
        return data;
      }
      return ["N/A"];
    },
    toggleCheckAll() {
      this.allChecked = !this.allChecked;

      if (this.allChecked) {
        this.data.forEach((el) => {
          if (!this.holdData.includes(el)) {
            this.holdData.push(el);
          }
        });
        console.log("CHECKED", this.holdData);
      } else {
        this.holdData = [];
      }

      this.$emit("selectedData", this.holdData);
    },
    findEmpId(id) {
      if (this.holdData && this.holdData.length > 0) {
        const found = this.holdData.find((emp) =>
          emp.employeeId === id ? true : false
        );

        return found;
      }
      return false;
    },
    updatePage(pageNumber) {
      this.currentPage = pageNumber;
      this.updateVisibleData();
    },
    updateVisibleData() {
      let datas = this.data;
      this.visibleData = datas.slice(
        this.currentPage * this.pageSize,
        this.currentPage * this.pageSize + this.pageSize
      );
      // if we have 0 visible todos, go back a page
      if (this.visibleData.length == 0 && this.currentPage > 0) {
        this.updatePage(this.currentPage - 1);
      }
    },
    showAll(arg) {
      if (this.showAllEmployee === arg) {
        this.showAllEmployee = "";
      } else {
        this.showAllEmployee = arg;
      }
    },
    onRowSelect(event) {
      if (this.holdData.includes(event)) {
        let index = this.holdData.indexOf(event);
        if (index > -1) {
          this.holdData.splice(index, 1);
        }
      } else {
        this.holdData.push(event);
      }
      this.$emit("selectedData", this.holdData);

      console.log(this.holdData, "EMV");
    },
    onRowUnselect(event) {
      this.holdData = this.holdData.filter((emp) => {
        return emp.employeeId !== event.data.employeeId;
      });
    },
    updateMultipleCells(event, objkey) {
      //   console.log("1", event, "2", obj, "3", objkey);
      this.active = objkey;
      for (let i = 0; i < this.holdData.length; i++) {
        if (event.target) {
          this.holdData[i][objkey] = event.target.value;
          //   obj[objkey] = event.target.value;
        } else {
          this.holdData[i][objkey] = event;
          //   obj[objkey] = event.value;
        }
      }
      this.$emit("mobileData", this.holdData);
      console.log(this.holdData, "WORKS?");
    },
    getKey(data, value) {
      if (value != null && value != undefined) {
        const key = Object.keys(data).find((key) => data[key] === value);
        // console.log(key, ">", value);
        return key;
      }
    },
    setActive(id, field) {
      if (this.routable === false) {
        this.transposed = [];
        console.log(id, field, "LO");
        this.transposed.push({ id, field });
        console.log(this.transposed, "ARR");
      } else {
        this.$router.push({
          name: this.$route.path.includes("edit")
            ? "EditSingleSalary"
            : "ViewSingleSalary",
          params: { id: id },
        });
      }
    },
    checkForTrue() {
      const mapped = this.transposed.map((item) => {
        item.index === true ? true : false;
      });
    },
    reset() {
      this.transposed = [{ id: "", field: "" }];
      this.$emit("mobileData", this.holdData);
    },
    checkValue(event, obj, objkey) {
      console.log(event.target.value, "VALUES");

      if (event.target.value != undefined && event.target.value != null) {
        if (this.holdData.length > 0) {
          this.holdData = this.holdData.filter(
            (emp) => emp.employeeId !== obj.employeeId
          );
        }

        this.holdData.push(obj);
        this.holdData = this.getUniqueListBy(this.holdData, "employeeId");
        console.log(this.holdData, "CHECKED");
      }
    },
    onSave() {},
    updateSelect(event, key, emp) {
      emp[key] = event;
      console.log(emp[key]);
      this.checkValue(event, key);
    },
    returnOptions(fieldType) {
      if (fieldType === "employmentType") {
        return this.mapData[0];
      } else if (fieldType === "branch") {
        return this.mapData[1];
      }
    },

    initials(name) {
      const arr = name.split(" ");
      const str = `${arr[0].charAt(0).toUpperCase()}${arr[1]
        .charAt(0)
        .toUpperCase()}`;
      return str;
    },
    getColor(index) {
      let n = (index * 0xfffff * 1000000).toString(16);
      return "#" + n.slice(0, 6);
    },
    getAvatar(emp) {
      let name = "",
        color;
      // Get color
      let alphabet = "abcdefghijklmnopqrstuvwxyz".split("");

      const initialOne = String(
        emp && emp.firstName && emp.firstName.charAt(0)
      );
      const initialTwo = String(emp && emp.lastName && emp.lastName.charAt(0));
      const num =
        Number(alphabet.indexOf(initialOne.toLowerCase())) +
        Number(alphabet.indexOf(initialTwo.toLowerCase()));
      color = this.getColor(num);

      // Get Shortend Name
      emp
        ? (name = `${emp && emp.firstName && emp.firstName.charAt(0)}${
            emp && emp.lastName && emp.lastName.charAt(0)
          }`)
        : "";

      return {
        color,
        name,
      };
    },

    bankError(data, field) {
      if (data.bankError) {
        console.log(data.bankError, "RE");

        const bankError = data.bankError;
        if (
          field === "bankName" ||
          field === "bankCode" ||
          field === "accountNumber"
        ) {
          return [
            {
              "border border-error-table w-full h-full text-error-table p-2":
                bankError.length > 0,
            },
          ];
        }
      }
    },
    error(data, field) {
      if (data.reason) {
        console.log(data.reason, "RE");

        const reason = data.reason;

        return [
          {
            "border border-error-table w-full h-full text-error-table p-2":
              reason.includes(field),
          },
        ];
      }
    },
    madatoryClass(data, field) {
      console.log("DA", data);
      return [
        {
          "border border-secondary w-full h-full text-secondary":
            data[field].length === 0,
        },
      ];
    },
    onCellEditComplete(event) {
      let { data, newValue, field } = event;
      console.log(newValue, "NEWS");

      switch (field) {
        case "quantity":
        case "price":
          if (this.isPositiveInteger(newValue)) data[field] = newValue;
          else event.preventDefault();
          break;

        default:
          if (newValue.trim().length > 0) data[field] = newValue;
          else event.preventDefault();
          break;
      }
    },
    isPositiveInteger(val) {
      let str = String(val);
      str = str.trim();
      if (!str) {
        return false;
      }
      str = str.replace(/^0+/, "") || "0";
      var n = Math.floor(Number(str));
      return n !== Infinity && String(n) === str && n >= 0;
    },
    onRowEditSave(event) {
      let { newData, index } = event;

      this.products2[index] = newData;
    },
    getStatusLabel(status) {
      switch (status) {
        case "INSTOCK":
          return "In Stock";

        case "LOWSTOCK":
          return "Low Stock";

        case "OUTOFSTOCK":
          return "Out of Stock";

        default:
          return "NA";
      }
    },
  },
  // beforeUpdate(){
  //   this.allChecked = false
  // },
  created() {
    if (this.hideAllowances === true) {
      const staticAllowances = ["basic", "transport", "housing"];
      for (let name of this.allowanceNames) {
        if (!staticAllowances.includes(name)) {
          this.hiddenFields.push(name);
        }
      }
    }
    this.updateVisibleData();
    // console.log(this.allowanceNames);
    //   this.visibleData = this.data;
  },
};
</script>

<style scoped></style>
